document.addEventListener('DOMContentLoaded', () => {
  const genderFilter = document.querySelector('.gender-filter');

  if (!genderFilter) return;

  const buttons = genderFilter.querySelectorAll('.gender-filter__btn');
  const generalCollectionPaths = new Set([
    '/collections/tops',
    '/collections/langarmshirts',
  ]);

  function getCollectionGender(collectionItem) {
    const collectionLink = collectionItem.querySelector('a[href*="/collections/"]');
    const collectionPath = collectionLink
      ? new URL(collectionLink.href, window.location.origin).pathname.replace(/\/$/, '')
      : '';

    if (generalCollectionPaths.has(collectionPath)) return 'all';

    return collectionItem.getAttribute('data-collection-gender') || 'all';
  }

  function applyGenderFilter(gender) {
    genderFilter.setAttribute('data-selected-gender', gender);

    buttons.forEach((button) => button.classList.remove('is-active'));

    const activeButton = [...buttons].find(
      (button) => button.getAttribute('data-gender-choice') === gender,
    );

    if (activeButton) activeButton.classList.add('is-active');

    document.querySelectorAll('[data-collection-gender]').forEach((collectionItem) => {
      const collectionGender = getCollectionGender(collectionItem);
      const shouldShow =
        gender === 'all'
          ? ['all', 'unisex', 'all-bags', 'unisex-bags'].includes(collectionGender)
          : [gender, 'all-bags', 'unisex-bags'].includes(collectionGender);

      collectionItem.classList.toggle('gender-hidden', !shouldShow);
    });
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      applyGenderFilter(button.getAttribute('data-gender-choice'));
    });
  });

  applyGenderFilter(genderFilter.getAttribute('data-selected-gender') || 'all');
});
